import { ServerPickleballOrder } from './serverPicklballOrder.model';
import { ReturnerCourtSide } from './returnerSide.model';
import { Game } from './game.model';

export interface Timeout {
    timeoutPerSet?: number;
    remainingTimeoutsPerSet?: number;
    timeoutPerMatch?: number;
    remainingTimeoutsPerMatch?: number;
}
export class Set {
    games?: Game[] = [];
    startDate?: Date;
    setFormat?: string; // Not used. It can be removed
    setNumber?: number;
    side1Score?: number = 0;
    side1TiebreakScore?: number; // Not used. It should be populated
    side2Score?: number = 0; 
    side2TiebreakScore?: number; // Not used. It should be populated
    timestamp?: Date; // Indicates end of the set
    winningSide?: number;
    returnerCourtSides?: ReturnerCourtSide[];
    serverPickleballOrders?: ServerPickleballOrder[];
    isCompleted?: boolean;
    timeout?:{
        side1: Timeout;
        side2: Timeout;
    };
    previousScoringType?: string;
}